/**
 * Browser-facing Next.js API routes for Backend proxy traffic.
 * See docs/backend-proxy.md.
 */
export const WEBSITE_BACKEND_PROXY_GRAPHQL = '/api/graphql'
export const WEBSITE_BACKEND_PROXY_MEDIA_OBJECTS = '/api/media-objects'
